import { closeModal, openModal } from "../containers/Modal";
import { TextType } from "../type/TextType";
import { ComponentF, createElement } from "../ui";
import { Input } from "./Input";

export const InputPrompt: ComponentF<{
  title: string;
  initial: string;
  onSubmit: (value: string) => void;
}> = (C, props) => {
  return [
    createElement(
      TextType,
      { x: 0, y: 0, h: 1, w: 24 },
      { title: props.title }
    ),
    createElement(
      Input,
      { x: 0, y: 1, h: 1, w: 24 },
      {
        initialValue: props.initial || "",
        onSubmit: (value: string) => {
          closeModal();
          props.onSubmit(value);
        },
      }
    ),
  ];
};

export const promptInput = (options: {
  title: string;
  initial?: string;
  onSubmit: (value: string) => void;
}) => {
  openModal(createElement(InputPrompt, { x: 0, y: 0, h: 3, w: 24 }, options));
};
